import { CaseResultView } from '../../../../features/Results/CaseResultView/CaseResultView';
import { NoResults } from '../../../../features/Results/NoResults/NoResults';
import { useFetchVariogramResults } from '../../../../hooks/useFetchVariogramResults';
import { CenteredLoader } from '../../../../components/CenteredLoader/CenteredLoader';

export const VariogramResults = () => {
  const { data, isLoading } = useFetchVariogramResults();

  if (isLoading) return <CenteredLoader />;

  return (
    <>
      {data !== undefined && data?.length > 0 ? (
        <CaseResultView variogramResultList={data} type="Variogram" />
      ) : (
        <NoResults />
      )}
    </>
  );
};
